import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./auth/login";
import ForgotPassword from "./auth/ForgotPassword";
import ResetPassword from "./auth/ResetPassword";
import ContactForm from "./auth/ContactForm";

export default function Router() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/contact" element={<ContactForm />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}
